import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-be-helper-text',
    templateUrl: './be-helper-text.component.html',
    standalone: false
})
export class HelperTextComponent {
  @Input()
  helperId?: string;

  @Input()
  helperType: 'neutral' | 'error' | 'success' = 'neutral';
}
